module.exports = __webpack_public_path__ + "static/media/arrow-up-red.de925cfe.svg";